import { createElement, memo, ReactNode, Suspense } from "react";
import { Loader } from "../ui/Loaders";
import { useGlobalLoaderRemover } from "./GlobalLoaderRemover";

export type PageLoaderProps = {
  children: ReactNode | ReactNode[]
}

export const PageLoader = memo<PageLoaderProps>(({ children }) => {
  return (
    <Suspense fallback={<Loader />}>
      {children}
    </Suspense>
  );
});
export const PageLoaderWithRemover = memo<PageLoaderProps>(({ children }) => {
  useGlobalLoaderRemover();

  return (
    <PageLoader>
      {children}
    </PageLoader>
  );
});

export function withPageLoader(children: ReactNode | ReactNode[], withRemover = true) {
  return createElement(withRemover ? PageLoaderWithRemover : PageLoader, undefined, children);
}

export default PageLoader;